/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Typography,
  Grid,
  Link,
  CardContent,
  CardHeader,
  Divider,
  LinearProgress,
  Container
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMounted from '../../../hooks/useMounted';
import { useCallback, useState, useEffect } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import ChevronRightIcon from '../../../icons/ChevronRight';
import moment from 'moment';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import GroupsIcon from '@mui/icons-material/Groups';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import { relaunchApi } from '../../../api/relaunchApi';
import RelaunchRecallsList from './RelaunchRecallsList';
import { DataGrid, GridToolbar, frFR } from '@mui/x-data-grid';
import RelaunchLearners from './RelaunchLearners';
import RelaunchCustomersList from './RelaunchCustomersList';
import { alpha } from '@mui/material/styles';
import { toneAlpha, lightVeil, greyAlpha, grey } from '../../../theme/tones';
import usePermissions from '../../../hooks/usePermissions';

const RelaunchInfo = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const { can } = usePermissions();
  const mounted = useMounted();
  const { endDateRelaunch, state } = useParams();
  const [progressionProspects, setProgressionProspects] = useState(0);
  const [numberProspects, setNumberProspects] = useState([]);
  const [numberProspectsSession, setNumberProspectsSession] = useState([]);
  const [numberProspectsTreated, setNumberProspectsTreated] = useState(0);
  const [showStats, setShowStats] = useState(true);
  const [idNextCustomer, setIdNextCustomer] = useState(1);
  const [countCustomersByWeekAndQualification, setCountCustomersByWeekAndQualification] = useState([]);
  const [countCustomersList, setCountCustomersList] = useState([]);

  const getRelaunchInfo = useCallback(async () => {
    try {
      const data = await relaunchApi.getRelaunchInfo(endDateRelaunch, state, localStorage.getItem('accessToken'));
      if (data.length === 0) {
        throw new Error('L\'apprenant n\'existe pas');
      }

      if (mounted.current) {
        setNumberProspects(data.numberProspects);
        setNumberProspectsSession(data.numberProspectsSession);
        setProgressionProspects((data.numberProspectsTreated / (data.numberProspectsSession.number === 0 ? 1 : data.numberProspectsSession.number)) * 100);
        setNumberProspectsTreated(data.numberProspectsTreated);
        setIdNextCustomer(data.idNextCustomer);
        setCountCustomersByWeekAndQualification(data.countCustomersByWeekAndQualification);
        setCountCustomersList(data.countCustomersList);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, endDateRelaunch, state]);

  useEffect(() => {
    getRelaunchInfo();
  }, [getRelaunchInfo]);

  const handleTabsChange = () => {
    setShowStats(!showStats);
  };

  const rows = {};
  if (Object.keys(countCustomersByWeekAndQualification).length !== 0) {
    Object.keys(countCustomersByWeekAndQualification).map((el) => {
      let totalDecalage = 0;
      rows[el] = [];
      let totalSuiviTel = 0;
      let totalAnnulation = 0;
      let totalPasRep = 0;
      let totalARappeler = 0;
      let totalNumInc = 0;
      let totalVaSeCo = 0;
      let totalSuiviMail = 0;
      let totalSuiviSMS = 0;

      Object.keys(countCustomersByWeekAndQualification[el]).map((itemRow) => {
        const row = {
          Annulation: countCustomersByWeekAndQualification[el][itemRow].Annulation === null ? 0 : countCustomersByWeekAndQualification[el][itemRow].Annulation.called_nb,
          'Pas répondu': countCustomersByWeekAndQualification[el][itemRow]['Pas répondu'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Pas répondu'].called_nb,
          'À rappeler': countCustomersByWeekAndQualification[el][itemRow]['À rappeler'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['À rappeler'].called_nb,
          'Numéro incorrect': countCustomersByWeekAndQualification[el][itemRow]['Numéro incorrect'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Numéro incorrect'].called_nb,
          'Va se connecter': countCustomersByWeekAndQualification[el][itemRow]['Va se connecter'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Va se connecter'].called_nb,
          'Suivi - Téléphone': countCustomersByWeekAndQualification[el][itemRow]['Suivi - Téléphone'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - Téléphone'].called_nb,
          Décalage: countCustomersByWeekAndQualification[el][itemRow].Décalage === null ? 0 : countCustomersByWeekAndQualification[el][itemRow].Décalage.called_nb,
          'Suivi - Mail': countCustomersByWeekAndQualification[el][itemRow]['Suivi - Mail'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - Mail'].called_nb,
          'Suivi - SMS': countCustomersByWeekAndQualification[el][itemRow]['Suivi - SMS'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - SMS'].called_nb,
          id: parseInt(itemRow, 10)
        };
        totalDecalage += countCustomersByWeekAndQualification[el][itemRow].Décalage === null ? 0 : countCustomersByWeekAndQualification[el][itemRow].Décalage.called_nb;
        totalSuiviTel += countCustomersByWeekAndQualification[el][itemRow]['Suivi - Téléphone'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - Téléphone'].called_nb;
        totalAnnulation += countCustomersByWeekAndQualification[el][itemRow].Annulation === null ? 0 : countCustomersByWeekAndQualification[el][itemRow].Annulation.called_nb;
        totalPasRep += countCustomersByWeekAndQualification[el][itemRow]['Pas répondu'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Pas répondu'].called_nb;
        totalARappeler += countCustomersByWeekAndQualification[el][itemRow]['À rappeler'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['À rappeler'].called_nb;
        totalNumInc += countCustomersByWeekAndQualification[el][itemRow]['Numéro incorrect'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Numéro incorrect'].called_nb;
        totalVaSeCo += countCustomersByWeekAndQualification[el][itemRow]['Va se connecter'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Va se connecter'].called_nb;
        totalSuiviMail += countCustomersByWeekAndQualification[el][itemRow]['Suivi - Mail'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - Mail'].called_nb;
        totalSuiviSMS += countCustomersByWeekAndQualification[el][itemRow]['Suivi - SMS'] === null ? 0 : countCustomersByWeekAndQualification[el][itemRow]['Suivi - SMS'].called_nb;
        rows[el].push(row);
      });
      
      const rowTotal = { id: 'Total' };
      rowTotal.Décalage = totalDecalage;
      rowTotal['Suivi - Téléphone'] = totalSuiviTel;
      rowTotal.Annulation = totalAnnulation;
      rowTotal['Suivi - SMS'] = totalSuiviSMS;
      rowTotal['Suivi - Mail'] = totalSuiviMail;
      rowTotal['Pas répondu'] = totalPasRep;
      rowTotal['À rappeler'] = totalARappeler;
      rowTotal['Numéro incorrect'] = totalNumInc;
      rowTotal['Va se connecter'] = totalVaSeCo;
      rows[el].push(rowTotal);
    });
  }

  const columns = [
    { field: 'id',
      headerName: 'N° semaine',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 700, color: 'text.primary' }}>{cellValues.row.id}</Typography>),
      width: 120
    },
    { field: 'Annulation',
      headerName: 'Annulation',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>{cellValues.row.Annulation}</Typography>),
      width: 120
    },
    { field: 'Pas répondu',
      headerName: 'Pas répondu',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>{cellValues.row['Pas répondu']}</Typography>),
      width: 120
    },
    { field: 'À rappeler',
      headerName: 'À rappeler',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 600, color: 'warning.main' }}>{cellValues.row['À rappeler']}</Typography>),
      width: 120
    },
    { field: 'Numéro incorrect',
      headerName: 'Numéro incorrect',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>{cellValues.row['Numéro incorrect']}</Typography>),
      width: 140
    },
    { field: 'Va se connecter',
      headerName: 'Va se connecter',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 600, color: 'info.main' }}>{cellValues.row['Va se connecter']}</Typography>),
      width: 140
    },
    { field: 'Suivi - Téléphone',
      headerName: 'Suivi - Téléphone',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 600, color: 'success.main' }}>{cellValues.row['Suivi - Téléphone']}</Typography>),
      width: 150
    },
    { field: 'Suivi - Mail',
      headerName: 'Suivi - Mail',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>{cellValues.row['Suivi - Mail']}</Typography>),
      width: 120
    },
    { field: 'Suivi - SMS',
      headerName: 'Suivi - SMS',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>{cellValues.row['Suivi - SMS']}</Typography>),
      width: 120
    },
    { field: 'Décalage',
      headerName: 'Décalage',
      headerAlign: 'center',
      renderCell: (cellValues) => (<Typography sx={{ margin: 'auto', fontSize: '0.85rem', fontWeight: 600, color: 'primary.main' }}>{cellValues.row.Décalage}</Typography>),
      width: 120
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'light' ? grey(50) : grey(950),
        minHeight: '100%',
        py: 4,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Soft glowing background blur spots for premium design */}
      <Box
        sx={{
          position: 'absolute',
          top: -100,
          left: -100,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: (theme) => `radial-gradient(circle, ${alpha(theme.palette.secondary.main, 0.08)} 0%, ${alpha(theme.palette.secondary.main, 0)} 70%)`,
          pointerEvents: 'none',
          zIndex: 0
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 200,
          right: -100,
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: (theme) => `radial-gradient(circle, ${alpha(theme.palette.success.main, 0.05)} 0%, ${alpha(theme.palette.success.main, 0)} 70%)`,
          pointerEvents: 'none',
          zIndex: 0
        }}
      />

      <Container maxWidth={false} disableGutters sx={{ px: 2, position: 'relative', zIndex: 1 }}>
        <Grid container spacing={3} sx={{ mb: 4, alignItems: 'center' }}>
          <Grid item xs={12} md={8}>
            <Typography
              color="text.primary"
              variant="h4"
              sx={{ fontWeight: 800, letterSpacing: '-0.025em' }}
            >
              Statistiques de la relance
            </Typography>
            <Typography
              color="text.secondary"
              variant="h5"
              sx={{ fontWeight: 700, mt: 0.5, letterSpacing: '-0.01em' }}
            >
              Semaine du {moment(endDateRelaunch).format('DD/MM/YYYY')}
            </Typography>
            
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<ChevronRightIcon fontSize="small" />}
              sx={{ mt: 1.5 }}
            >
              <Link
                color="text.primary"
                component={RouterLink}
                to="/dashboard"
                variant="subtitle2"
                underline="hover"
              >
                Tableau de bord
              </Link>
              <Link
                color="text.primary"
                component={RouterLink}
                to="/dashboard/relaunch"
                variant="subtitle2"
                underline="hover"
              >
                Relance
              </Link>
              <Typography
                color="text.secondary"
                variant="subtitle2"
              >
                Informations
              </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, alignItems: 'center', gap: 2 }}>
            {can('relaunch.manage', user.access_level === 0) && (
              <Button
                variant="outlined"
                startIcon={<StackedLineChartIcon fontSize="small" />}
                onClick={handleTabsChange}
                sx={{ 
                  borderRadius: '12px', 
                  textTransform: 'none', 
                  fontWeight: 600,
                  borderWidth: '1.5px',
                  '&:hover': {
                    borderWidth: '1.5px',
                    backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.04) : toneAlpha('blue', 0.15)
                  }
                }}
              >
                {showStats === true ? 'Apprenants' : 'Statistiques'}
              </Button>
            )}
            {idNextCustomer !== null && !can('relaunch.manage', user.access_level === 0) && numberProspectsSession.number > 0 && idNextCustomer.called_nb === 0 && (
              <Button
                component={RouterLink}
                to={`/dashboard/relaunch/${state}/${endDateRelaunch}/customer/${idNextCustomer.id}`}
                color="primary"
                variant="contained"
                sx={{
                  background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                  boxShadow: (theme) => `0 4px 14px ${alpha(theme.palette.secondary.main, 0.3)}`,
                  borderRadius: '14px',
                  textTransform: 'none',
                  fontWeight: 700,
                  color: grey(0),
                  px: 3.5,
                  py: 1,
                  '&:hover': {
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                    transform: 'translateY(-1px)',
                    boxShadow: (theme) => `0 6px 20px ${alpha(theme.palette.secondary.main, 0.4)}`
                  },
                  transition: 'all 0.25s ease-in-out'
                }}
              >
                {numberProspectsTreated !== 0 ? 'Continuer la relance' : 'Commencer la relance'}
              </Button>
            )}
          </Grid>
        </Grid>

        {showStats === true && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  p: 3.5,
                  borderRadius: '24px',
                  border: '1px solid',
                  borderColor: 'divider',
                  backgroundColor: 'background.paper',
                  backdropFilter: 'blur(20px)',
                  boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  height: '100%',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.08) : toneAlpha('blue', 0.15),
                    color: 'primary.main',
                    width: 56,
                    height: 56,
                    boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.secondary.main, 0.05)}`
                  }}
                >
                  <GroupsIcon fontSize="medium" />
                </Avatar>
                <Box>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Nombre de prospects total
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: 'text.primary', mt: 0.5 }}>
                    {numberProspects.number || 0}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Nombre de prospects en cours
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary', mt: 0.5 }}>
                    {numberProspectsSession.number || 0}
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  p: 3.5,
                  borderRadius: '24px',
                  border: '1px solid',
                  borderColor: 'divider',
                  backgroundColor: 'background.paper',
                  backdropFilter: 'blur(20px)',
                  boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  height: '100%',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: theme.palette.mode === 'light' ? toneAlpha('emerald', 0.08) : toneAlpha('emerald', 0.15),
                    color: 'success.main',
                    width: 56,
                    height: 56,
                    boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.success.main, 0.05)}`
                  }}
                >
                  <SafetyDividerIcon fontSize="medium" />
                </Avatar>
                <Box>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Nombre traité
                  </Typography>
                  <Typography variant="h3" sx={{ fontWeight: 800, color: 'success.main', mt: 0.5 }}>
                    {numberProspectsTreated || 0}
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  p: 3.5,
                  borderRadius: '24px',
                  border: '1px solid',
                  borderColor: 'divider',
                  backgroundColor: 'background.paper',
                  backdropFilter: 'blur(20px)',
                  boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 2 }}>
                  Progression sur la semaine en cours
                </Typography>
                <Box sx={{ width: '100%', mr: 1 }}>
                  <LinearProgress
                    value={progressionProspects < 100 ? progressionProspects : 100}
                    variant="determinate"
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      backgroundColor: 'divider',
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 5,
                        background: (theme) => `linear-gradient(90deg, ${theme.palette.secondary.main} 0%, ${theme.palette.success.main} 100%)`
                      }
                    }}
                  />
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                    Progression
                  </Typography>
                  <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 800 }}>
                    {Number.isNaN(progressionProspects) ? 0 : progressionProspects.toFixed(2) < 100 ? progressionProspects.toFixed(2) : 100}%
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {can('relaunch.process', user.id_service === 4) && (
              <Grid item xs={12} sx={{ mt: 2 }}>
                <RelaunchRecallsList />
              </Grid>
            )}

            {showStats && (
              Object.keys(countCustomersByWeekAndQualification).map((el) => (
                <Grid item xs={12} key={el} sx={{ mt: 3 }}>
                  <Card
                    sx={{
                      borderRadius: '24px',
                      border: '1px solid',
                      borderColor: 'divider',
                      backgroundColor: 'background.paper',
                      backdropFilter: 'blur(20px)',
                      boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
                      overflow: 'hidden'
                    }}
                  >
                    <Box sx={{ p: 3, borderBottom: `1px solid ${theme.palette.divider}`, bgcolor: 'action.hover' }}>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
                        {`Nombre de commentaires pour date de début ${moment(el).format('DD/MM/YYYY')} par statut`}
                      </Typography>
                    </Box>
                    <CardContent sx={{ p: 0 }}>
                      <Box sx={{ width: '100%' }}>
                        <DataGrid
                          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                          initialState={{
                            sorting: {
                              sortModel: [{ field: 'id', sort: 'desc' }],
                            },
                          }}
                          autoHeight
                          rowHeight={52}
                          rows={rows[el]}
                          columns={columns}
                          pageSize={50}
                          rowsPerPageOptions={[50, 100]}
                          components={{ Toolbar: GridToolbar }}
                          sx={{
                            border: 'none',
                            px: 2,
                            '& .MuiDataGrid-columnHeaders': {
                              backgroundColor: theme.palette.mode === 'light' ? grey(100) : greyAlpha(900, 0.3),
                              borderBottom: `1px solid ${theme.palette.divider}`,
                              borderRadius: '12px',
                              fontWeight: 700
                            },
                            '& .MuiDataGrid-columnHeader': {
                              color: 'text.secondary',
                            },
                            '& .MuiDataGrid-cell': {
                              borderBottom: theme.palette.mode === 'light' ? `1px solid ${grey(100)}` : `1px solid ${lightVeil(0.03)}`,
                              color: 'text.primary',
                              fontSize: '0.85rem'
                            },
                            '& .MuiDataGrid-row:hover': {
                              backgroundColor: 'action.hover',
                            },
                            '& .MuiDataGrid-footerContainer': {
                              borderTop: 'none'
                            }
                          }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}

            {can('relaunch.process', user.id_service === 4) && showStats && (
              <Grid item xs={12} sx={{ mt: 3 }}>
                <RelaunchCustomersList countCustomersList={countCustomersList} />
              </Grid>
            )}
          </Grid>
        )}

        {showStats === false && (
          <Box sx={{ mt: 3 }}>
            {can('relaunch.manage', user.access_level === 0) && (
              <RelaunchLearners />
            )}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default RelaunchInfo;
